import { render, staticRenderFns } from "./userdetails.vue?vue&type=template&id=3be4b1df&"
import script from "./userdetails.vue?vue&type=script&lang=js&"
export * from "./userdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports